import * as React from 'react';
/**
 * Assigns value to a ref function or object
 */

export function assignRef(ref, value) {
  if (ref === null) return;

  if (typeof ref === 'function') {
    ref(value);
    return;
  }

  try {
    ref.current = value;
  } catch (error) {
    throw new Error("Cannot assign value to ref ".concat(ref));
  }
}
/**
 * Combines multiple React refs into a single ref function
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 */

export function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (value) {
    refs.forEach(function (ref) {
      return assignRef(ref, value);
    });
  };
}
export function callAllHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function (event) {
    fns.forEach(function (fn) {
      fn === null || fn === void 0 ? void 0 : fn(event);
    });
  };
}